var PES = PES || {};
PES.LoginViewModel = function () {
    var self = this;

    self.displayLoadingSpinner = ko.observable(false);
    self.isReseller = ko.observable(false);
    self.loginOrRegister = PES.LoginOrRegisterModel;
    self.loginOrRegister.isCheckoutFlow(false);
    self.loginOrRegister.isReseller = ko.computed(function () { return self.isReseller(); });

    self.loginOrRegister.registerEventListeners(self);
    self.loginOrRegister.loginOrRegisterValidation = new PES.SectionValidationModel(self.loginOrRegister);
    self.isReseller.subscribe(function () { self.loginOrRegister.checkEmail(); });

    self.loginOrRegisterSection = new PES.SectionModel("login-or-register", PES.LoginOrRegisterModel.validate, self.loginOrRegister.loginOrRegisterValidation.hasBeenValidated);
    self.loginOrRegisterSection.displayLoginOrRegister = ko.computed(function () {
        return self.loginOrRegister.displayLoginOrRegister();
    });

    self.displayResetPasswordExpired = function (displayResetPasswordExpired) {
        self.loginOrRegister.displayResetPasswordExpired(displayResetPasswordExpired);
    }
    self.displayForceLoggedOut = function (displayForceLoggedOut) {
        self.loginOrRegister.displayForceLoggedOut(displayForceLoggedOut);
    }

    self.clearErrors = function () {
        self.loginOrRegister.loginOrRegisterValidation.cleanErrors();
        self.loginOrRegister.loginOrRegisterValidation.errors.showAllMessages(false);
    }

    self.goToNextStep = function () {
        self.loginOrRegister.validate(self, self.redirectAfterLogin);
    }

    self.redirectAfterLogin = function (data, redirectUrl) {
        if (redirectUrl) {
            self.loginOrRegisterSection.display(false);
        }
        window.location.href = data.RedirectUrl;
    }

    self.loginOrRegisterTitle = ko.computed(function () {
        if (self.loginOrRegister.displayLoginOrRegister()) {
            if (self.isReseller()) {
                return PES.Resources.SignInorRegister() + " " + PES.Resources.AsReseller();
            } else {
                return PES.Resources.SignInorRegister();
            }
        }
        if (self.loginOrRegister.displayLogin()) {
            if (self.isReseller()) {
                return PES.Resources.SignIn() + " " + PES.Resources.AsReseller();
            } else {
                return PES.Resources.SignIn();
            }
        }
        if (self.loginOrRegister.displayRegister()) {
            if (self.isReseller()) {
                return PES.Resources.Register() + " " + PES.Resources.AsReseller();
            } else {
                return PES.Resources.Register();
            }
        }
        if (self.loginOrRegister.displayLoggedIn()) {
            if (self.isReseller()) {
                return PES.Resources.SignedInAsReseller() + " " + self.loginOrRegister.email();
            } else {
                return PES.Resources.SignedInAs() + " " + self.loginOrRegister.email();
            }
        }
        return PES.Resources.SignInorRegister();
    });

    self.loginOrRegister.displayRegister.subscribe(function (newValue) {
        $('.strengthify-wrapper').toggle(newValue);
    });
}